import React, { useState, useEffect } from "react";
import random from "../../assets/random_pp.png";
import Footer from "../../components/Footer/Footer";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/actions/userActions";
import styles from "./Account.module.css";

const Account = ({ history }) => {
  const dispatch = useDispatch();

  const { adminInfo } = useSelector((state) => state.adminLoginReducer);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  // useEffect(() => {
  //   if (!userInfo || !adminInfo) {
  //     history.push("/login");
  //   }
  // }, [history, userInfo, adminInfo]);

  return (
    <div className={styles.container}>
      <div className={styles.box}></div>
      <header>
        <h1>Account</h1>
        <div className={styles.profile}>
          <img src={random} alt="random-pic" />
          <div className={styles.textContainer}>
            {userInfo && <h2>{userInfo.name}</h2>}
            <Link to="/my-profile">
              <small>View profile</small>
            </Link>
          </div>
        </div>
      </header>

      <main>
        {/* <div className={styles.row}>
          <i className={styles.icon + " fas fa-map-marker-alt"}></i>
          <div className={styles.rowText}>
            <h2>Saved Addresses</h2>
            <p>Save address for quick process</p>
          </div>
        </div> */}
        <div className={styles.row}>
          <i className={styles.icon + " fas fa-envelope"}></i>
          {/* <Link> */}
          <div className={styles.rowText}>
            <h2>Contact us</h2>
            <a
              href="https://web.whatsapp.com/send?phone=+393427056246"
              target="__blank"
            >
              <p>Connect us for any query {"&"} issue</p>
            </a>
          </div>
          {/* </Link> */}
        </div>
        <div className={styles.row}>
          <i className={styles.icon + " fas fa-file-alt"}></i>
          <Link to="/terms">
            <div className={styles.rowText}>
              <h2>Terms {"&"} Conditions</h2>
              <p>Know our Terms {"&"} Conditions</p>
            </div>
          </Link>
        </div>
        <div className={styles.row}>
          <i className={styles.icon + " fas fa-user-astronaut"}></i>
          <div className={styles.rowText}>
            <h2>Do you like this App?</h2>
            <a href="mailto:mrasadullah0@gmail.com">
              <p>Contact Developer</p>
            </a>
          </div>
        </div>
        <div className={styles.row}>
          <i className={styles.icon + " fas fa-vector-square"}></i>
          <div className={styles.rowText}>
            <h2>Share App</h2>
            <p>Share with friends and family</p>
          </div>
        </div>
        <div className={styles.row}>
          <i className={styles.icon + " fas fa-sign-out-alt"}></i>
          <div
            className={styles.rowText}
            onClick={() => dispatch(logout(history))}
          >
            <h2>Logout</h2>
            <p>Signout from current account</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Account;
